import React, { useState } from "react";
import { observer } from "mobx-react";
import QuestionareStore from "../stores/QuestionareStore";

function TextBoxComponent({inputKey}){
    const handleOnChange = (event) =>{
        QuestionareStore.setTextInputValue(inputKey, event.target.value)
    }
    return(
        <textarea 
            id="input-form"
            placeholder="Write your thoughts below"
            value={QuestionareStore.getTextInputValue(inputKey)}
            onChange={handleOnChange}
            name="inputForm"
            style={{width:'23rem', 
                height: '20rem', 
                border: 'none', 
                padding: '1rem',
                borderRadius:'12px',
                backgroundColor:'#F2F2F2',
                outline: 'none'
            }}
        />
    )
} 

export default observer(TextBoxComponent);